import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgCustomers = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "inherit",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M19.778 3.2h-1.111V1h-2.223v2.2H7.556V1H5.333v2.2h-1.11A2.21 2.21 0 0 0 2 5.4v15.4c0 1.21.989 2.2 2.222 2.2h15.556C21 23 22 22.01 22 20.8V5.4c0-1.21-1-2.2-2.222-2.2zM12 6.5c1.844 0 3.333 1.474 3.333 3.3 0 1.826-1.489 3.3-3.333 3.3s-3.333-1.474-3.333-3.3c0-1.826 1.489-3.3 3.333-3.3zm6.667 13.2H5.333v-1.1c0-2.2 4.445-3.41 6.667-3.41 2.222 0 6.667 1.21 6.667 3.41v1.1z",
			fillRule: "nonzero"
		})
	})
});
export default SvgCustomers;
